import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-portfolio',
  imports: [SectionWrapperComponent, MatIconModule, MatButtonModule],
  templateUrl: './portfolio.component.html',
  styleUrl: './portfolio.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortfolioComponent {
  private readonly siteConfig = inject(SiteConfigService);

  readonly section = this.siteConfig.portfolio;
}
